import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadEarning: -1,
    loadDay: -1,
    loadAvailableClinic: -1,
  },
  data: {},
  clinic: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.REPORT_EARNING_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadEarning: 0,
        },
      };
    case ACTION_TYPES.REPORT_EARNING_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadEarning: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.REPORT_EARNING_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadEarning: 2,
        },
        error,
      };
    case ACTION_TYPES.REPORT_EARNING_CLINIC_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadAvailableClinic: 0,
        },
      };
    case ACTION_TYPES.REPORT_EARNING_CLINIC_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadAvailableClinic: 1,
        },
        clinic: payload.data,
      };
    case ACTION_TYPES.REPORT_EARNING_CLINIC_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadAvailableClinic: 2,
        },
        error,
      };
    default:
      return state;
  }
}
